/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidatorEscrowStatsInfo,
    ValidatorEscrowStatsInfoFromJSON,
    ValidatorEscrowStatsInfoFromJSONTyped,
    ValidatorEscrowStatsInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ValidatorEscrowStatsResponse
 */
export interface ValidatorEscrowStatsResponse {
    /**
     * 
     * @type {Array<ValidatorEscrowStatsInfo>}
     * @memberof ValidatorEscrowStatsResponse
     */
    list: Array<ValidatorEscrowStatsInfo>;
}

export function ValidatorEscrowStatsResponseFromJSON(json: any): ValidatorEscrowStatsResponse {
    return ValidatorEscrowStatsResponseFromJSONTyped(json, false);
}

export function ValidatorEscrowStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorEscrowStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ValidatorEscrowStatsInfoFromJSON)),
    };
}

export function ValidatorEscrowStatsResponseToJSON(value?: ValidatorEscrowStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ValidatorEscrowStatsInfoToJSON)),
    };
}


